import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class ProofingApi {
  createProofing(payload) {
    return api.post(API_URLS.URL.proofing.createProofing, payload);
  }

  updateProofing(proofingId, payload) {
    return api.put(
      API_URLS.URL.proofing.updateProofing?.replace(":id", proofingId),
      payload,
    );
  }

  getProofingList(payload) {
    return api.post(API_URLS.URL.proofing.getProofingList, payload);
  }

  sendToProofingApi(payload) {
    return api.post(API_URLS.URL.proofing.sendToProofing, payload);
  }

  getSpiritListAssociateProofing(payload) {
    return api.post(
      API_URLS.URL.proofing.getSpiritListAssociateProofing,
      payload,
    );
  }

  unlinkSpiritWithProofing(payload) {
    return api.post(API_URLS.URL.proofing.unlinkSpiritWithProofing, payload);
  }

  deleteProofing(subLogId) {
    return api.delete(
      API_URLS.URL.proofing.deleteProofing?.replace(":id", subLogId),
    );
  }
}
